import { provideZoneChangeDetection, APP_INITIALIZER, ErrorHandler, importProvidersFrom } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { CookieConsentService } from "./app/services/cookie-consent-service.service";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideNgxMask, NgxMaskDirective } from "ngx-mask";
import { MyMonitoringService } from "./app/services/logging.service";
import { ErrorHandlerService } from "./app/services/errorHandlerService.service";
import { DatePipe, CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { provideRouter } from "@angular/router";
import { routes } from "./app/app.routes";
import { AppComponent } from "./app/app.component";
import { provideNativeDateAdapter } from '@angular/material/core';

export function initializeCookieConsent(cookieService: CookieConsentService) {
  return () => cookieService.loadCookieScripts();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(CommonModule, BrowserModule, NgxMaskDirective),
        provideRouter(routes),
        {
            provide: APP_INITIALIZER,
            useFactory: initializeCookieConsent,
            deps: [CookieConsentService],
            multi: true
        },
        provideAnimationsAsync(),
        provideNativeDateAdapter(),
        provideNgxMask(),
        MyMonitoringService,
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
  .catch(err => console.error(err));
